import React from "react";
import FileInput from "../../atoms/FileInput/FileInput";
import { useFormContext } from "react-hook-form";
import Input from "../../atoms/Input/Input";

const HeaderLogo = () => {
  const {
    formState: { errors },
    register,
    control,
    getValues,
  } = useFormContext();
  return (
    <div className="flex-column gap-20">
      <FileInput
        label="Logo*"
        register={register}
        registerName="logo"
        disabled={false}
        accept="image/png,image/jpeg,image/jpg,image/svg+xml"
        control={control}
        errorMessage={errors?.logo?.message}
        value={getValues("logo") ?? ""}
      />
      <Input
        type="text"
        placeholder="Title"
        label="Title*"
        register={register}
        registerName="headerBannerTitle"
        errorMessage={errors?.headerBannerTitle?.message}
      />
    </div>
  );
};

export default HeaderLogo;
